import React from 'react';

interface EnvContextProps {
    captchaKey: string;
}

export const EnvContext = React.createContext<Partial<EnvContextProps>>({});
